import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box } from '@cad-arc';
import { useQueueStore } from '../context/use-queue-store';
import { QueueRows } from './queue-rows';
import { GroupedQueueRows } from './grouped-queue-rows';
import { queueRowTestIds } from './test-ids';
import { RawQueueRowData } from '../store/types-2';
import { ContextMenuStateProvider } from '../context/context-menu-state-provider';

export const Queue = observer(function Queue({
    onClose,
    onRowDoubleClick,
}: {
    onClose: () => void;
    onRowDoubleClick: (row: RawQueueRowData) => void;
}): React.ReactElement {
    const store = useQueueStore();

    const RowsComponent =
        store.listStore.data.mode === 'GROUPED_LIST' ? GroupedQueueRows : QueueRows;

    return (
        <Box
            density={store.workspacePanel.queue.displayDensity}
            data-testid={queueRowTestIds.QUEUE_ROWS}
            className={`queue-wrapper ${store.workspacePanel.queue.displayDensity.toLowerCase()}`}
            style={{
                textAlign: 'left',
                height: '100%',
                paddingRight: '3px',
                paddingBottom: '3px',
            }}
        >
            <ContextMenuStateProvider>
                <RowsComponent
                    store={store}
                    onRowDoubleClick={onRowDoubleClick}
                    onClosePanel={onClose}
                />
            </ContextMenuStateProvider>
        </Box>
    );
});
